import { OrderModel } from '../models/order.model';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { CustomerService } from './customer.service';
import { Estate } from '../utils/enum.util';
import { MagasinService } from './magasin.service';
import { Router } from '@angular/router';
import { PosturalService } from './postural.service';
import { BikeService2 } from './bike2.service';

@Injectable()
export class OrderService {

    private antiRebound = 300;
    private timestamp   = 0;

    current              = null;
    currentState: Estate = Estate.Save;

    listOver: OrderModel[]       = [];
    listInProgress: OrderModel[] = [];
    isOpen: boolean             = false;

    constructor(public bikeService:BikeService2, public posturalService:PosturalService, public router:Router, public apiService: ApiService, public customerService: CustomerService, public magasinService:MagasinService) {

    }

    load(order){
        this.current = order;
        this.posturalService.getAll(this.current.client.id);
    }

    delete(order: OrderModel) {
        this.apiService.delete('order/' + order.id, null).subscribe((_res)=> {
            if (this.router.url == '/tasks')
                this.router.navigate(['/tasks']);
            else{
                this.customerService.tabActive = 'Résumé';
            }
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    create(clientPrivateId: string) {
        this.apiService.post('client/' + clientPrivateId + '/order', null).subscribe((_res)=> {
            this.customerService.tabActive = 'Résumé';
            this.posturalService.getAll(clientPrivateId);
            this.current = OrderModel.j2o(_res.data, this);
            //update resume
            this.customerService.resume.nbrOrders++;
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    get(id: string) {
        this.apiService.get('order/' + id, '').subscribe((_res)=> {
            this.load(OrderModel.j2o(_res.data, this));
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    duplicate(order: OrderModel) {
        this.current.state = Estate.Saving;
        this.apiService.post('client/' + order.client.id + '/order', null).subscribe((_res1)=> {
            this.apiService.put('order/' + _res1.data.id, OrderModel.o2j(order)).subscribe((_res2)=> {
                _res2.data.client = _res1.data.client;
                let tmp = this.current.paid;
                this.current = OrderModel.j2o(_res2.data, this);
                this.current.paid = tmp;
                this.customerService.tabActive = 'Résumé';
                this.customerService.resume.nbrOrders++;
            }, (_err)=> {
                this.apiService.error(_err);
            });
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    generateBill(order: OrderModel){
        this.apiService.get('order/' + order.id + '/generateBill', '').subscribe((_res)=> {
            this.current = null;
            this.router.navigate(['invoice', _res.data.clientPrivateId , _res.data.id])
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    update(order: OrderModel) {
        let data;

        data = OrderModel.o2j(order);

        //antiRebounce
        this.timestamp        = new Date().getTime();
        setTimeout(()=> {
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('order/' + order.id, data).subscribe((_res)=> {
                    if (this.current) {
                        if (!this.current.errors)
                            order.state = Estate.Save;
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                    order.state = Estate.Error;
                });
            }
        }, this.antiRebound);
    }

    /*delete(service: ServModel) {
        this.apiService.delete('service', {'privateId': service.privateId}).subscribe((_res)=> {
            this.router.navigate(['/tasks']);
        }, (_err)=> {
            this.apiService.error(_err);
        });
    }

    updateField(service: ServModel) {
        //antiRebounce
        this.timestamp = new Date().getTime();

        setTimeout(()=> {
            let data = {
                'privateId': service.privateId,
                'about'    : service.about,
                'price'    : 0
            };
            if (service.price)
                data.price = service.price;
            if (this.timestamp + this.antiRebound <= new Date().getTime()) {
                this.apiService.put('service', data).subscribe((_res)=> {
                    //update activities
                    if (service.clientPrivateId == this.customerService.activities.privateId) {
                        for (let i = 0; i < this.customerService.activities.data.length; i++) {
                            if (this.customerService.activities.data[i].type && this.customerService.activities.data[i].type == 'Service' && this.customerService.activities.data[i]._id == service.privateId) {
                                this.customerService.activities.data[i].price = service.price;
                                this.customerService.activities.data[i].about = service.about.toString();
                            }
                        }
                    }
                }, (_err)=> {
                    this.apiService.error(_err);
                });
            }
        }, this.antiRebound);
    }*/
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/home/services/order.service.ts